module.exports = __webpack_public_path__ + "media/images/heart-a4dbb6f360b3350c3b1624b21c1fc64c.svg";